import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConstants } from '../../constants/app.constants';
import { environment } from '../../../environments/environment.prod';
import { CompanyPlanModel, FeatureStatusModel, PlanChangeRequestModel } from '../../models/company.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  controller: string = 'SkeinContent/';
  baseUrl: string = AppConstants.accessBaseUrl;
  API_KEY = environment.secreteKey;
  private readonly headers = new HttpHeaders({ 'x-api-key': this.API_KEY, 'Content-Type': 'application/json' });
  options = { headers: this.headers };

  constructor(private readonly http: HttpClient) { }

  changePlanRequest(changePlanData: PlanChangeRequestModel): Observable<any> {
    return this.http.post(this.baseUrl + 'Company/' + AppConstants.changePlanRequest, JSON.stringify(changePlanData), this.options);
  }

  getCompanyPlans() {
    return this.http.get<CompanyPlanModel[]>(this.baseUrl + 'Company/' + AppConstants.getCompanyPlans, this.options);
  }

  getActivePlanUid() {
    return this.http.get<string>(this.baseUrl + 'Company/' + AppConstants.getActivePlanUid, this.options);
  }

  getSkeinCompanyName() {
    return this.http.get(this.baseUrl + this.controller + AppConstants.getSkeinCompanyName, this.options);
  }

  getFeatureStatus() {
    return this.http.get<FeatureStatusModel[]>(this.baseUrl + this.controller + AppConstants.getFeatureStatus, this.options);
  }

  getCompanyDetails() {
    return this.http.get<any>(this.baseUrl + 'Post/' + AppConstants.getCompanyDetails, this.options);
  }
}
